import { Module } from "@/modules/centralAdmin/enums";
import type { RouteRecordRaw } from "vue-router";

export default <RouteRecordRaw[]>[
  {
    path: "",
    meta: {
      module: Module.Tenant,
    },
    children: [
      {
        path: "/tenants",
        name: "tenantAdmin.index",
        component: () =>
          import("@/modules/centralAdmin/tenant/views/TenantIndex.vue"),
      },
      {
        path: "/tenants/:tenantId",
        name: "tenantAdmin.show",
        component: () =>
          import("@/modules/centralAdmin/tenant/views/TenantView.vue"),
      },
    ],
  },
];
